import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, Modal, Transfer } from 'antd';
import { allApps } from '../../../configs/AppsConfig';
import { impersonateAndUpdateUser } from "../../../store/slices/superUser.slice";

const UserAppManager = ({ userId, userAppKeys }) => {
    const dispatch = useDispatch();
    const [targetKeys, setTargetKeys] = useState([]);

    // State to hold the Transfer data
    const [transferData, setTransferData] = useState([]);

    // Update function using Redux dispatch
    const handleUpdateUserApps = useCallback((updatedApps) => {
        dispatch(impersonateAndUpdateUser({
            userId,
            updateQuery: {
                match: { uid: userId },
                update: {
                    $set: {
                        'settings._app_whitelist': updatedApps,
                        'settings.apps': updatedApps
                    }
                }
            }
        }));
    }, [dispatch, userId]);


    // Prepare data for the Transfer component
    useEffect(() => {
        const initData = allApps.map(app => ({
            key: app.key,
            title: app.label,
            description: app.label,
            iconUrl: app.iconUrl
        }));
        setTransferData(initData);
        setTargetKeys(userAppKeys);
    }, [userAppKeys]);

    // Handle the change of selected items
    const handleChange = (nextTargetKeys) => {
        setTargetKeys(nextTargetKeys);
    };

    // Render item with additional details (e.g., icon)
    const renderItem = (item) => ({
        label: (
            <div>
                <img src={item.iconUrl} alt={item.title} style={{ width: 24, marginRight: 8 }} />
                {item.title}
            </div>
        ),
        value: item.title
    });

    // Submit changes, e.g., to backend or local storage
    const handleSubmit = () => {
        handleUpdateUserApps(targetKeys);
        Modal.info({
            title: 'Update Successful',
            content: `The user's apps have been updated.`,
        });
    };

    return (
        <Card title="Manage User Applications">
            <Transfer
                dataSource={transferData}
                titles={['Available Apps', 'User Apps']}
                targetKeys={targetKeys}
                onChange={handleChange}
                render={renderItem}
                listStyle={{
                    width: 250,
                    height: 300,
                }}
                showSearch
            />
            <Button type="primary" onClick={handleSubmit} style={{ marginTop: 16 }}>
                Submit Changes
            </Button>
        </Card>
    );
};

export default UserAppManager;
